import { gql } from '@apollo/client';

export interface ILibraryOpeningHours {
  id: string;
  mondayOpen: string;
  mondayClose: string;
  tuesdayOpen: string;
  tuesdayClose: string;
  wednesdayOpen: string;
  wednesdayClose: string;
  thursdayOpen: string;
  thursdayClose: string;
  fridayOpen: string;
  fridayClose: string;
  saturdayOpen: string;
  saturdayClose: string;
  sundayOpen: string;
  sundayClose: string;
}

export const LibraryOpeningHoursFragment = gql`
  fragment LibraryOpeningHours on LibraryOpeningHours {
    sys {
      id
    }
    mondayOpen
    mondayClose
    tuesdayOpen
    tuesdayClose
    wednesdayOpen
    wednesdayClose
    thursdayOpen
    thursdayClose
    fridayOpen
    fridayClose
    saturdayOpen
    saturdayClose
    sundayOpen
    sundayClose
  }
`;
